navApp.default.animation('.nav-slide-down', [
  'animateSpeed', function(animateSpeed) {
    return {
      addClass: function(el, className, doneFn) {
        jQuery(el).fadeOut(animateSpeed, function() {
          el.height('auto');
          return doneFn();
        });
        return false;
      },
      removeClass: function(el, className, doneFn) {
        jQuery(el).css({
          display: 'none'
        }).slideDown(animateSpeed, doneFn);
        return false;
      }
    };
  }
]);

navApp.default.animation('.nav-slide-out', [
  'updateHeight', function(updateHeight) {
    return {
      addClass: function(el, className, doneFn) {
        jQuery(el).parents('li').eq(0).removeClass('active');
        return doneFn();
      },
      removeClass: function(el, className, doneFn) {
        updateHeight(el, className, doneFn);
        return false;
      }
    };
  }
]);
